import { render, staticRenderFns } from "./PartnerOrderTable.vue?vue&type=template&id=8543b944"
import script from "./PartnerOrderTable.vue?vue&type=script&lang=js"
export * from "./PartnerOrderTable.vue?vue&type=script&lang=js"
import style0 from "./PartnerOrderTable.vue?vue&type=style&index=0&id=8543b944&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports